import React from "react";

import { Switch, Route } from "2g-router";
import PageContent from "2g-page-content";

import { PATHS, PAGE_TITLES } from "b2b/constants";
import ZadostiHistorieGrid from "b2b/components/zadosti-historie-grid/ZadostiHistorieGrid.jsx";
import ZadostiOdbaveniGrid from "b2b/components/zadosti-odbaveni-grid/ZadostiOdbaveniGrid.jsx";

import RezervaceVytvoreni from "./RezervaceVytvoreni";
import RezervaceCasovyPlan from "./RezervaceCasovyPlan";

export function Rezervace() {
  return (
    <div>
      <Switch>
        <Route
          role={["admin", "vuz_spravce", "vuz_edit"]}
          path={PATHS.REZERVACE.ODBAVENI}
          title={PAGE_TITLES.REZERVACE_ODBAVENI}
        >
          <PageContent>
            <ZadostiOdbaveniGrid />
          </PageContent>
        </Route>
        <Route
          path={PATHS.REZERVACE.HISTORIE}
          title={PAGE_TITLES.REZERVACE_HISTORIE}
        >
          <PageContent>
            <ZadostiHistorieGrid />
          </PageContent>
        </Route>
        <Route
          path={PATHS.REZERVACE.VYTVORENI}
          title={PAGE_TITLES.REZERVACE_VYTVORENI}
        >
          <RezervaceVytvoreni />
        </Route>
        <Route
          path={PATHS.REZERVACE.CASOVY_PLAN}
          title={PAGE_TITLES.REZERVACE_CASOVY_PLAN}
        >
          <RezervaceCasovyPlan />
        </Route>
      </Switch>
    </div>
  );
}

Rezervace.propTypes = {};

export default React.memo(Rezervace);
